export var EEstimationTargets;

(function (EEstimationTargets) {
  EEstimationTargets[EEstimationTargets["flat"] = 0] = "flat";
  EEstimationTargets[EEstimationTargets["house"] = 1] = "house";
  EEstimationTargets[EEstimationTargets["land"] = 2] = "land";
  EEstimationTargets[EEstimationTargets["newbuilding"] = 3] = "newbuilding";
})(EEstimationTargets || (EEstimationTargets = {}));

export var ESuburbanEstimationCategory;

(function (ESuburbanEstimationCategory) {
  ESuburbanEstimationCategory["LandSale"] = "landSale";
  ESuburbanEstimationCategory["HouseSale"] = "houseSale";
})(ESuburbanEstimationCategory || (ESuburbanEstimationCategory = {}));